export default __webpack_public_path__ + "static/media/credit-card.f50fe960.svg";